module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("口コミ一覧")]), _vm._v(" "), _c('template', {
    slot: "tools"
  }), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("1.口コミを選択")]), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "splitTitle"
  }, [_vm._v("\n              口コミ\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_vm._l((_vm.beforeReviews), function(review) {
    return [_c('div', {
      staticClass: "vSelect",
      on: {
        "click": function($event) {
          return _vm.appendId(review.review_id)
        }
      }
    }, [_c('table', {
      staticClass: "table ",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v("会社名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.company_name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("プロジェクト名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.project_title))])])])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "splitTitle"
  }, [_vm._v("\n              口コミ(選択済)\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_vm._l((_vm.afterReviews), function(review) {
    return [_c('div', {
      staticClass: "vSelect",
      on: {
        "click": function($event) {
          return _vm.removeId(review.review_id)
        }
      }
    }, [_c('table', {
      staticClass: "table ",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v("会社名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.company_name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("プロジェクト名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.project_title))])])])])]
  })], 2)]), _vm._v(" "), (_vm.selectReview) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.viewReviewId) + "\n            " + _vm._s(_vm.selectReview) + "\n            "), _c('table', [_vm._v("\n              口コミID:" + _vm._s(_vm.selectReview.review_id) + "\n              会社名:" + _vm._s(_vm.selectReview.company_name) + "\n              プロジェクト名:" + _vm._s(_vm.selectReview.project_title) + "\n              駅名:" + _vm._s(_vm.selectReview.company_station) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.selectReview.review_id) + "\n\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("2.会社を選択")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchCompanyName),
      expression: "searchCompanyName"
    }],
    staticClass: "m-r-md",
    attrs: {
      "type": "text",
      "placeholder": "会社名を入力"
    },
    domProps: {
      "value": (_vm.searchCompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchCompanyName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-primary",
    on: {
      "click": _vm.searchCompany
    }
  }, [_vm._v("検索")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/company/create"
    }
  }, [_vm._v("新規作成")])]), _vm._v(" "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "splitTitle"
  }, [_vm._v("\n            会社\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_vm._l((_vm.companies), function(company) {
    return [_c('div', {
      staticClass: "vSelect",
      on: {
        "click": function($event) {
          _vm.selectCompanyId = company.company_id
        }
      }
    }, [_c('table', {
      staticClass: "table ",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v("会社名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.name))])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v("住所")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.address))])])])])]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("3.更新")]), _vm._v(" "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "splitTitle"
  }, [_vm._v("\n            対象の口コミ\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_vm._l((_vm.afterReviews), function(review) {
    return [_c('div', {
      staticClass: "vSelect"
    }, [_c('table', {
      staticClass: "table ",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "width": "100px"
      }
    }, [_vm._v("会社名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.company_name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("プロジェクト名")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(review.project_title))])])])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "split"
  }, [_c('div', {
    staticClass: "splitTitle"
  }, [_vm._v("\n            対象の会社\n          ")]), _vm._v(" "), (_vm.selectCompany) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_vm._v("\n                会社名\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.selectCompany.name) + "\n                (" + _vm._s(_vm.selectCompany.name_kana) + ")\n\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("住所")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectCompany.address))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.updateCompany
    }
  }, [_vm._v("レビューを更新")])])])])])]), _vm._v(" "), _c('line-dashed')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a64bd0b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/review/Check.vue
// module id = 469
// module chunks = 1